import type { IInitialEvent } from '../types';

export type TEventOverrides = Partial<IInitialEvent>;

export const withEventOverrides = (event: IInitialEvent, overrides?: TEventOverrides): IInitialEvent => ({
  ...event,
  ...overrides,
});
